import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addMedicationToDb, updateMedicationInDb } from 'store/localDb';
import { addMed, setMedsLoaded } from 'store/storeValtio';
import { getCurrentUserId } from 'store/storeValtio';
import { medsCreateState, resetMedsCreateState } from 'store/storeValtio'; 
import MedicationSummary from './MedicationSummary';

export default function MedicationConfirm({ prevStep }) {
  //console.log('MedConfirm', medsCreateState);
  const [submitting, setSubitting] = useState(false);
  const navigate = useNavigate();
  const currentUserId = getCurrentUserId();
  //console.log('currentUserId', currentUserId);

  async function handleSubmit(event) {
    event.preventDefault();

    const medVals = {
      //id: 0,
      medicationId: '',
      userId: '',
      labelId: '',
      name: 'new med',
      type: 'O',
      brand: '',
      orangeId: '0',
      description: '',
      form: 'TABLET',
      dosage: '1',
      strength: '10MG',
      occurance: '1',
      often: 'daily',
      schedule: [],
      isPaused: false,
      withMeals: false,
      sortOrder: 99,
    };

    medVals.medicationId = medsCreateState.medicationId;
    medVals.userId = currentUserId;
    medVals.labelId = '';
    medVals.name = medsCreateState.name;
    medVals.type = medsCreateState.type;
    medVals.brand = medsCreateState.brand;
    medVals.orangeId = medsCreateState.orangeId;
    medVals.form = medsCreateState.form;
    medVals.dosage = medsCreateState.dosage;
    medVals.strength = medsCreateState.strength;
    medVals.schedule = JSON.parse(JSON.stringify(medsCreateState.schedule));
    medVals.often = medsCreateState.often;
    medVals.occurance = medsCreateState.occurance;
    medVals.sortOrder = medsCreateState.sortOrder;

    try {
      setSubitting(true);
      // add new med
      //console.log('addMed', medVals);
      await addMedicationToDb(medVals);
      addMed(medVals);
      setMedsLoaded(true);  // not sure why this is needed
      resetMedsCreateState();
    } catch (err) {
      //console.log('med submit error', err.message);
    } finally {
      setSubitting(false);
      navigate('/');
    }
  }

  return (
    <div>
      <MedicationSummary summary={medsCreateState} />
      <div className='mcard-body flex justify-center'>
            <button
              className='hpBtn mt-20 bg-blue-800 text-2xl'
              onClick={handleSubmit}
              disabled={submitting}
              type='submit'
            >
              Confirm Add New Medication
            </button>
      </div>
    </div>
  );
}
